export default "__VITE_ASSET__CPo8vRYb__"